export const PIC_DELIMITER = "|";

export type SideLoadedMatchedField = "abn" | "pic" | "brands" | "email";

export const MATCHED_FIELD_LABELS: Record<SideLoadedMatchedField, string> = {
  abn: "ABN",
  pic: "PIC",
  brands: "Brands",
  email: "Email",
};

// A row in either the Data Suggestions grid or the Manage grid. Both source
// their rows from selectSideLoadedBusinessesGridList, so datasetLabel is always
// present; matchedFields only applies to a searched suggestion.
export type SideLoadedBusinessRow = SideLoadedBusiness & {
  datasetLabel: string;
  matchedFields?: SideLoadedMatchedField[];
  validationIssues?: string[];
};
